
import { observer } from 'mobx-react-lite';
import SVGPureIcon from '@ui/svg-icon';
import chatStoreManager from '@/store/chat/manager';
import checkStore from '@/store/checkStore';
import FoldBtn from '@/ui/fold-btn';
import EE from '@/common/event';
import client from '@/store/client';
import copyShareStore from './store';
import AgentConversationMenu from './agent-conversation-menu';

/**
 * 分享对话按钮
 * @param {*} props
 * @returns
 */
export const ShareConversationBtn = props => {
  const { small, chatStore } = props;
  const isMcpServer = chatStoreManager.current?.lastMessage?.cloud_mcp?.length > 0 || chatStoreManager.current?.lastMessage?.mcp?.length > 0;
  const { isMcpAgent, isAgentFlow } = chatStoreManager.current?.mcpStore || {};

  return (
    <div className="group relative last-of-type:mr-0">
      <FoldBtn
        onClick={
          () => {
            chatStore.log({
              action : "click",
              set : "share_chat",
            });

            copyShareStore.copyLink();
          }
        }
        text={'分享对话'}
        iconName="chat_share_v2"
        className="!h-32px"
        small={small}
        isMcpAgent={isMcpAgent || isMcpServer || isAgentFlow}
        circle
      />
      {/* 只有在mcp智能体对话才显示 */}
      {isMcpAgent || isMcpServer || isAgentFlow ? <AgentConversationMenu /> : null}
    </div>
  );
};

export default observer(ShareConversationBtn);
